import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

type Request = {
  folderId: PilotId;
  documents: PilotId[];
  folders: PilotId[];
  parentFolder: PilotId;
  selectAll: boolean;
};

type ServerRequest = {
  documents: PilotId[];
  folders: PilotId[];
  parent_folder: PilotId;
  select_all: boolean;
};

type ServerResponse = {
  skipped_folder_names?: string[];
};

type Response = {
  skippedFolderNames?: string[];
};

export const folderBulkCopy = async ({
  folderId,
  ...request
}: Request): Promise<Response> => {
  const response: ServerResponse = await pilot.put(
    `folder/${folderId}/copy/`,
    mapParams(request),
  );

  return mapResponse(response);
};

const mapParams = ({
  selectAll,
  parentFolder,
  ...request
}: Omit<Request, 'folderId'>): ServerRequest => ({
  ...request,
  parent_folder: parentFolder,
  select_all: selectAll,
});

const mapResponse = (response: ServerResponse): Response => ({
  skippedFolderNames: response.skipped_folder_names,
});
